import { createSelector } from 'reselect'

import { RootState } from 'redux/store'
import { Flavour } from 'types/Flavour'

const selectFlavour = createSelector(
  (state: RootState) => state.layout.flavour,
  (flavour: Flavour) => flavour
)

export default selectFlavour
